import React from "react";

import ECD from "../components/ECD";

const Reassembly = (props) => {
    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Re-Assembly</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>Your vehicle is being put back together. All the new parts as well as any of your original parts that had to be removed or repaired during the body repair and paint process will be put back on your vehicle. This is generally the longest phase of the repair process. Although we work hard to make sure we have all the parts here before this phase begins, there are times that we must order specialty rivets, clips, bolts, or screws to complete the re-assembly.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>What is next?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>After the vehicle is re-assembled, the vehicle will be cleaned up and then go into quality checks.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>Estimated Completion Date</h4>
                <span className="decor" />
                <ECD ecd={props.VehEntry.EstimatedCompletionDate} />
            </div>
        </div>
    )
}

export default Reassembly